module.exports = __webpack_public_path__ + "img/pdf.72706575.png";